module.exports = __webpack_public_path__ + "static/media/transport.95c476cd.png";